import React from 'react';
import '../css/education.css';

const Education = () => {
  return (
    <section id="education" className="education-section">
      <h2>Education</h2>
      <p>Master of Science in Computer Applications (2018)</p>
      <p>Bachelor of Science in Electronics (2014)</p>
    </section>
  );
};

export default Education;
